import { FormattedMessage, IntlProvider } from "react-intl";
import jobMessages from "../translate/jobMessages";
import { useContext } from "react";
import { LangContext } from "../App";
import Offer from "../images/offer.png";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
import ContactLink from "../components/ContactLink";
import library from "../images/library.jpg";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const Job = () => {
  const language = useContext(LangContext);

  const iab_pl = [
    "gromadzisz dane w teczkach lub arkuszach kalkulacyjnych, a wyszukiwanie danych jest uciążliwe?",
    "posiadasz bazę dokumentów, które wymagają obiegu w firmie?",
    "potrzebujesz koordynacji działań oraz uprawnień między Zespołami w istniejącym systemie, którego nie da się łatwo zmienić?",
    "potrzebujesz wsparcia w rozwoju i utrzymaniu środowiska? ",
  ];

  const iab_en = [
    "gathers data in folders or spreadsheets, making data search cumbersome,",
    "has a database of documents that require circulation within the company,",
    "needs coordination of actions and permissions between teams in an existing system that is difficult to change,",
    "needs support in the development and maintenance of the environment",
  ];

  const erp_pl = [
    "zrozumienie procesów biznesowych i integrację ze starymi systemami.",
    "konfiguracja systemu ERP zgodnie z niestandardowymi potrzebami organizacji.",
    "określanie parametrów systemowych oraz uprawnień i ról użytkowników.",
    "szkolenie, wsparcie techniczne oraz przygotowanie materiałów instruktażowych.",
    "prowadzenie testów integracyjnych, jakościowych i zarządzanie zmianą.",
    "koordynacja zespołu projektowego oraz tworzenie wskaźników wydajności (KPI).",
  ];

  const erp_en = [
    "understanding business processes and integrating with legacy systems,",
    "configuring ERP systems to meet the organization's specific requirements,",
    "defining system parameters, user permissions, and roles,",
    "providing training, technical support, and preparing user documentation,",
    "conducting integration and quality testing, and managing change,",
    "coordinating project teams and developing Key Performance Indicators (KPIs).",
  ];

  const si_pl = [
    "realizacja zgodnie z indywidualnie ustalonym projektem graficznym,",
    "nowoczesny, responsywny wygląd i wysoka jakość wykonania,",
    "możliwość samodzielnej edycji treści (CMS),",
    "łatwa obsługa i kompleksowe wsparcie techniczne po wdrożeniu.",
  ];

  const si_en = [
    "Websites are developed according to individually agreed graphic designs.",
    "I provide a modern, responsive look and high-quality execution.",
    "I offer the possibility of independent content editing by the client (CMS).",
    "I guarantee easy operation and comprehensive technical support after deployment.",
  ];
  const sd_pl = [
    "masz oprogramowanie, którego nikt nie wspiera, a istnieje konieczność dokonania zmian, które są istotne dla Firmy,",
    "poszukujesz osoby z dużym doświadczeniem w kilku językach oprogramowania, które powszechnie mogą już być nieużywane i ich znajomość może okazać się przydatna w takich przypadkach,",
  ];
  const sd_en = [
    "an IT team leader capable of motivating the team to achieve shared goals, possessing the organizational and planning skills necessary for effective IT project management, and demonstrating excellent communication and negotiation abilities to build positive relationships with clients and colleagues;",
    "a leader who executes IT budgets in close coordination with the company’s management board, focuses on results and competencies, and is adept at making decisions amidst volatility and time pressure experienced IT team leader who will ensure effective management and the delivery of high-quality IT services.",
  ];
  const zs_pl = [
    "lidera zespołu IT, który potrafi motywować zespół do osiągania wspólnych celów, posiadającego umiejętności organizacyjne i planistyczne, umożliwiające skuteczne zarządzanie projektami IT, posiadającego bardzo dobrą zdolność komunikacji i negocjacji, która potrafi budować pozytywne relacje z klientami i współpracownikami;",
    "lidera, który realizuje założenia budżetu IT ściśle w porozumieniu z Zarządem Firmy i koncentruję się na wynikach i umiejętnościach oraz podejmowaniu decyzji w warunkach zmienności i presji czasu;",
    "doświadczonego lidera zespołu IT, który zapewni skuteczne zarządzanie i wysoką jakość usług informatycznych;",
  ];
  const zs_en = [
    "an IT team leader who can motivate the team to achieve shared goals, possesses the organizational and planning skills necessary for effective IT project management, and demonstrates excellent communication and negotiation abilities—enabling the building of positive relationships with clients and colleagues;",
    "a leader who manages IT budgets in close alignment with the company’s executive management, focuses on results and competencies, and is capable of making decisions amidst volatility and time pressure;",
    "an experienced IT team leader who will ensure effective management and the delivery of high-quality IT services;",
  ];
  const wit_pl = [
    "zależy Ci na szybkiej diagnozie sprzętu IT i ograniczeniu przestojów w pracy, zapewnię sprawną pomoc techniczną;",
    "potrzebujesz pomocy w instalacji aplikacji lub konfiguracji sprzętu? Oferuję wsparcie zdalne, telefoniczne i bezpośrednio w Twojej firmie;",
    "chcesz mieć pewność, że Twoja infrastruktura IT działa stabilnie i bezpiecznie? Zadbam o monitorowanie wydajności, kopie zapasowe i regularne aktualizacje;",
    "zależy Ci na uporządkowanej dokumentacji IT? Przygotuję raporty serwisowe i bazę wiedzy, które ułatwią użytkownikom codzienną pracę.",
  ];
  const wit_en = [
    "need fast IT troubleshooting and want to minimize downtime, I'll provide efficient technical support to keep your business running smoothly.",
    "need help installing applications or configuring hardware? I offer remote, phone, and on-site assistance tailored to your team's needs.",
    "want to keep your IT infrastructure stable and secure? I'll take care of performance monitoring, regular backups, and software updates.",
    "looking to keep your IT documentation organized? I'll prepare service reports and a knowledge base to make everyday tasks easier for your users.",
  ];

  const textVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };
  const styles = {
    card: {
      background: "#ffffff",
      borderRadius: "4px",
      padding: "36px",
      boxShadow: "0 10px 30px -10px rgba(0,0,0,0.04)",
      border: "1px solid #e2e8f0",
      height: "100%",
      boxSizing: "border-box",
    },
    cardHeaderGradient: {
      background: "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
      padding: "10px",
      borderRadius: "22px",
      textAlign: "left",
      marginBottom: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    cardTitleGradient: {
      color: "#fff",
      fontSize: "20px",
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: "20px",
      paddingLeft: "10px",
    },
  };
  const cardContentStyle = {
    p: 4,
    pt: 0,
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "1340px",
    maxWidth: "100%",
  };
  const cardStyle = {
    height: "100%",
    borderRadius: "24px",
    boxShadow: "0 10px 30px -10px rgba(0,0,0,0.04)",
    border: "1px solid #e2e8f0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  };
  const listStyle = {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    m: 0,
    p: 0,
    listStyle: "none",
  };

  const introHeadingStyle = {
    fontSize: { xs: "20px", md: "23px" },
    fontWeight: 600,
    color: "#1e3a5f",
    mb: 2,
    mt: 0,
    letterSpacing: "0.2px",
    position: "relative",
    pl: 2,
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: "10%",
      height: "80%",
      width: "4px",
      borderRadius: "4px",
      backgroundColor: "#4f46e5",
    },
  };

  const renderList = (skills) => (
    <Box component="ul" sx={listStyle}>
      {skills.map((skill, index) => (
        <Box
          component="li"
          key={`${index}-${skill}`}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.5,
            color: "#475569",
            fontSize: "15px",
            lineHeight: 1.6,
          }}
        >
          <CheckCircleOutlineIcon
            sx={{
              color: "#274C77",
              fontSize: 19,
              flexShrink: 0,
              mt: "2px",
            }}
          />
          <Box component="span">{skill}</Box>
        </Box>
      ))}
    </Box>
  );

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "OfferCatalog",
            name: "Oferta usług Fullstack Developera",
            url: "https://michaljaskulski.pl/oferta",
            itemListElement: [
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Aplikacje webowe w React",
                  description:
                    "Projektowanie i tworzenie nowoczesnych aplikacji SPA w React, Vite i Next.js.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Backend API (Node.js / PHP)",
                  description:
                    "Tworzenie skalowalnych backendów, REST API oraz integracji z bazami danych.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Systemy biznesowe dla firm",
                  description:
                    "Dedykowane systemy usprawniające procesy biznesowe i raportowanie.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Bazy danych MySQL i MSSQL",
                  description:
                    "Projektowanie struktur, optymalizacja zapytań, migracje i backupy.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Konfiguracja i utrzymanie serwerów VPS",
                  description:
                    "Linux, Docker, SSL, monitoring i utrzymanie środowisk produkcyjnych.",
                },
              },
            ],
          })}
        </script>
        <title>Internetowe aplikacje bazodanowe | Strony internetowe</title>
        <meta
          name="description"
          content="Nowoczesne i bezpieczne responsywne aplikacje bazodanowe"
        />
      </Helmet>

      <Box className="page-container">
        <IntlProvider locale={language} messages={jobMessages[language]}>
          <AnimatePresence>
            <motion.div
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={textVariants}
            >
              <Container maxWidth="lg">
                <Box sx={{ textAlign: "center", mb: 6 }}>
                  <h1>
                    <FormattedMessage id="offer" />
                  </h1>
                </Box>
                <Grid container spacing={4} alignItems="stretch">
                  <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "1fr",
                          md: "1.5fr 1fr",
                        },
                        gap: 2,
                        width: "100%",
                        alignItems: "stretch",
                      }}
                    >
                      {/* LEWA STRONA – KARTA */}
                      <Card sx={{ ...cardStyle, width: "100%" }}>
                        <Box
                          sx={{
                            background:
                              "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                            p: 2,
                            borderRadius: "20px 20px 0 0",
                            mb: 3,
                          }}
                        >
                          <h2 style={styles.cardTitleGradient}>
                            <FormattedMessage id="webapp" />
                          </h2>
                        </Box>

                        <CardContent sx={cardContentStyle}>
                          <Typography component="h3" sx={introHeadingStyle}>
                            {language === "pl" ? "Jeśli" : "If you"}
                          </Typography>

                          {renderList(language === "pl" ? iab_pl : iab_en)}
                          <ContactLink language={language} />
                        </CardContent>
                      </Card>

                      {/* PRAWA STRONA – ZDJĘCIE */}
                      <Box
                        sx={{
                          position: "relative",
                          minHeight: { xs: 220, md: 0 },
                          borderRadius: "20px",
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          component="img"
                          src={library}
                          alt="Web application"
                          sx={{
                            position: "absolute",
                            inset: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="implementation" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        {renderList(language === "pl" ? erp_pl : erp_en)}
                        <Typography component="h3" sx={introHeadingStyle}>
                          {language === "pl"
                            ? "Jeśli Twoja firma potrzebuje systemu ERP – tworzonego od podstaw lub zintegrowanego z innymi systemami"
                            : "If your company needs an ERP system – built from scratch or integrated with other systems"}
                        </Typography>
                        <ContactLink language={language} />
                      </CardContent>
                    </Card>
                  </Grid>
                  {/* KARTA 3: website */}
                  <Grid item xs={12} md={6}>
                    <Card
                      sx={{
                        height: "100%",
                        borderRadius: "24px",
                        boxShadow: "0 10px 30px -10px rgba(0,0,0,0.04)",
                        border: "1px solid #e2e8f0",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="website" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        {renderList(language === "pl" ? si_pl : si_en)}
                        <Typography component="h3" sx={introHeadingStyle}>
                          {language === "pl"
                            ? "Jeśli potrzebujesz nowoczesnej strony internetowej i chcesz zarządzać jej treścią samodzielnie"
                            : "If you need a modern website and want to manage its content yourself"}
                        </Typography>
                        <ContactLink language={language} />
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* KARTA 4: development */}
                  <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="development" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        <Typography component="h3" sx={introHeadingStyle}>
                          {language === "pl" ? "Jeśli" : "If you"}
                        </Typography>
                        {renderList(language === "pl" ? sd_pl : sd_en)}
                        <ContactLink language={language} />
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* KARTA 5: managerit */}
                  <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="managerit" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        <Typography component="h3" sx={introHeadingStyle}>
                          {language === "pl"
                            ? "Jeśli szukasz"
                            : "If you are looking for"}
                        </Typography>
                        {renderList(language === "pl" ? zs_pl : zs_en)}
                        <ContactLink language={language} />
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* KARTA 6: supportit */}
                  <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="supportit" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        <Typography component="h3" sx={introHeadingStyle}>
                          {language === "pl" ? "Jeśli " : "If you "}
                        </Typography>
                        {renderList(language === "pl" ? wit_pl : wit_en)}
                        <ContactLink language={language} />
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

                {/* Call to Action & Image Section 
                <Box sx={{ textAlign: "center", mt: 8 }}>
                  {Offer && (
                    <Box sx={{ mt: 4 }}>
                      <Box
                        component="img"
                        src={Offer}
                        alt="Offer landscape screen"
                        sx={{
                          maxWidth: "100%",
                          width: "400px",
                          height: "auto",
                          borderRadius: "20px",
                          boxShadow: "0 20px 40px -20px rgba(0,0,0,0.1)",
                        }}
                      />
                    </Box>
                  )}
                </Box>
                */}
              </Container>
            </motion.div>
          </AnimatePresence>
        </IntlProvider>
      </Box>
    </>
  );
};

export default Job;
